import {
  loginModalImg,
  loginPopupBack,
  newArticleIcon,
  newChatIcon,
  newEmailIcon,
  newStoryIcon,
  wBack,
} from "assestes";
import AuthContext from "contexts/authContext";
import React, { useContext, useState } from "react";
import _ from "lodash";
import "./style.css";
import { trackButtonClick } from "utils";
import { useHistory } from "react-router-dom";
import { Paths } from "utils/constant";

const LoginModal = (props) => {
  const { auth } = useContext(AuthContext);

  const [selectedBox, setSelectedBox] = useState("");
  let { startNow } = props;
  const history = useHistory();

  const closeOverlayModal = () => {
    trackButtonClick("Login Entery Modal", "Close");
    document.getElementById("login-overlay-modal").style.width = "0%";
  };

  if (window.innerWidth < 750) {
    return (
      <div
        className="mobile-login-overlay-modal"
        id="login-overlay-modal"
        style={{ backgroundImage: `url(${wBack})` }}
      >
        <div className="header-title">
          Hello, {_.get(auth, "userData.FirstName", "")}!
        </div>
        <div className="header-desc">What would you like to write?</div>
        <div className="box-section">
          <div
            className={`box hover-zoom ${
              selectedBox === "article" ? "selected-box" : ""
            }`}
            onClick={() => {
              trackButtonClick("Login Entery Modal", "Article");
              setSelectedBox("article");
            }}
          >
            <div className="box-title">Article</div>
            <div className="box-desc">Informative</div>
            <div>
              <img
                className="box-img"
                src={newArticleIcon}
                width={62}
                alt="box img 1"
              />
            </div>
          </div>
          <div
            className={`box hover-zoom ${
              selectedBox === "story" ? "selected-box" : ""
            }`}
            onClick={() => {
              trackButtonClick("Login Entery Modal", "Story");
              setSelectedBox("story");
            }}
          >
            <div className="box-title">Story Writing</div>
            <div className="box-desc">Poetry, story writing, etc</div>
            <div>
              <img
                className="box-img"
                src={newStoryIcon}
                width={62}
                alt="box img 1"
              />
            </div>
          </div>
          <div
            className={`box hover-zoom ${
              selectedBox === "general" ? "selected-box" : ""
            }`}
            onClick={() => {
              trackButtonClick("Login Entery Modal", "Email");
              setSelectedBox("general");
            }}
          >
            <div className="box-title">Email</div>
            <div className="box-desc">Cold emails, complaints, etc</div>
            <div>
              <img
                className="box-img"
                src={newEmailIcon}
                width={62}
                alt="box img 1"
              />
            </div>
          </div>
          <div
            className={`box hover-zoom ${
              selectedBox === "chat" ? "selected-box" : ""
            }`}
            onClick={() => {
              trackButtonClick("Login Entery Modal", "Chat");
              setSelectedBox("chat");
            }}
          >
            <div className="box-title">Chat</div>
            <div className="box-desc">Everything you can imagine!</div>
            <div>
              <img
                className="box-img"
                src={newChatIcon}
                width={62}
                alt="box img 1"
              />
            </div>
          </div>
        </div>
        <div className="btn-section">
          <button
            disabled={selectedBox === ""}
            className={`hover-zoom trial-btn ${
              selectedBox === "" ? "disabled-trial-btn" : ""
            }`}
            onClick={() => {
              trackButtonClick("Login Entery Modal", "Start Now");
              if (selectedBox === "chat") {
                history.push(Paths.emptyChat);
              } else {
                startNow(selectedBox);
              }
            }}
          >
            {" "}
            Start Now{" "}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div id="login-overlay-modal" className="login-overlay-modal">
      <div className="back-img">
        <img src={loginPopupBack} alt="loginPopupBack" />
      </div>
      {/* <ChromeExtensions /> */}
      <div className="header-section">
        <span
          // eslint-disable-next-line no-script-url
          href="javascript:void(0)"
          className="closebtn hover-pink"
          onClick={closeOverlayModal}
        >
          &times;
        </span>
        <img className="overlay-img" src={loginModalImg} alt="modal img" />
        <div className="header-title">
          Hello, {_.get(auth, "userData.FirstName", "")}!
        </div>
        <div className="header-desc">What would you like to write?</div>
      </div>
      <div className="box-section">
        <div
          className={`box hover-zoom ${
            selectedBox === "article" ? "selected-box" : ""
          }`}
          onClick={() => {
            trackButtonClick("Login Entery Modal", "Article");
            setSelectedBox("article");
            startNow("article");
          }}
        >
          <div>
            <img className="box-img" src={newArticleIcon} alt="box img 1" />
          </div>
          <div className="box-title">Article</div>
          <div className="box-desc">Informative (articles, report, etc)</div>
        </div>
        <div
          className={`box hover-zoom ${
            selectedBox === "story" ? "selected-box" : ""
          }`}
          onClick={() => {
            trackButtonClick("Login Entery Modal", "Story");
            setSelectedBox("story");
            startNow("story");
          }}
        >
          <div>
            <img className="box-img" src={newStoryIcon} alt="box img 1" />
          </div>
          <div className="box-title">Story</div>
          <div className="box-desc">Poetry, story writing, etc</div>
        </div>
        <div
          className={`box hover-zoom ${
            selectedBox === "general" ? "selected-box" : ""
          }`}
          onClick={() => {
            trackButtonClick("Login Entery Modal", "Email");
            setSelectedBox("general");
            startNow("general");
          }}
        >
          <div>
            <img className="box-img" src={newEmailIcon} alt="box img 1" />
          </div>
          <div className="box-title">Email</div>
          <div className="box-desc">Cold emails, complaints, etc</div>
        </div>
        <div
          className={`box hover-zoom ${
            selectedBox === "chat" ? "selected-box" : ""
          }`}
          onClick={() => {
            trackButtonClick("Login Entery Modal", "Chat");
            setSelectedBox("chat");
            history.push(Paths.emptyChat);
          }}
        >
          <div className="new-label">
            <svg
              width="237"
              height="43"
              viewBox="0 0 237 43"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_10_37)">
                <rect
                  x="7"
                  y="7"
                  width="224"
                  height="27"
                  rx="13.5"
                  fill="#CF5FA6"
                  shape-rendering="crispEdges"
                />
                <path
                  d="M32.0312 25V17.1475H33.3203V25H32.0312ZM42.3863 25H40.8018L36.9561 18.7319H36.9078C36.9221 18.9432 36.9346 19.167 36.9454 19.4033C36.9597 19.6396 36.9704 19.8831 36.9776 20.1338C36.9883 20.3844 36.9973 20.6387 37.0045 20.8965V25H35.8336V17.1475H37.4073L41.2476 23.3726H41.2852C41.2781 23.1899 41.2691 22.9805 41.2584 22.7441C41.2476 22.5078 41.2369 22.2643 41.2261 22.0137C41.219 21.7594 41.2136 21.5142 41.21 21.2778V17.1475H42.3863V25ZM48.235 18.1304C47.859 18.1304 47.5224 18.1984 47.2252 18.3345C46.9316 18.4705 46.6827 18.6675 46.4786 18.9253C46.2745 19.1795 46.1188 19.4893 46.0113 19.8545C45.9039 20.2161 45.8502 20.6243 45.8502 21.0791C45.8502 21.6878 45.9362 22.2124 46.108 22.6528C46.2799 23.0897 46.5413 23.4263 46.8922 23.6626C47.2431 23.8953 47.6871 24.0117 48.2242 24.0117C48.5572 24.0117 48.8813 23.9795 49.1964 23.915C49.5115 23.8506 49.8374 23.7629 50.1739 23.6519V24.7476C49.8553 24.8729 49.533 24.9642 49.2071 25.0215C48.8813 25.0788 48.5053 25.1074 48.0792 25.1074C47.2771 25.1074 46.6111 24.9409 46.0812 24.6079C45.5548 24.2749 45.1609 23.8058 44.8995 23.2007C44.6417 22.5955 44.5128 21.8866 44.5128 21.0737C44.5128 20.4793 44.5952 19.9351 44.7599 19.4409C44.9246 18.9468 45.1645 18.5207 45.4796 18.1626C45.7947 17.8009 46.1832 17.5234 46.6451 17.3301C47.1106 17.1331 47.6424 17.0347 48.2404 17.0347C48.6342 17.0347 49.021 17.0794 49.4005 17.1689C49.7836 17.2549 50.1381 17.3784 50.464 17.5396L50.0128 18.603C49.7407 18.4741 49.456 18.3631 49.1588 18.27C48.8616 18.1769 48.5537 18.1304 48.235 18.1304ZM52.3005 25V17.1475H53.5895V23.9043H56.925V25H52.3005ZM64.8899 17.1475V22.2285C64.8899 22.7764 64.7735 23.2669 64.5408 23.7002C64.3116 24.1335 63.9643 24.4772 63.4988 24.7314C63.0333 24.9821 62.4478 25.1074 61.7424 25.1074C60.7362 25.1074 59.97 24.8442 59.4436 24.3179C58.9208 23.7879 58.6594 23.0843 58.6594 22.207V17.1475H59.9485V22.0942C59.9485 22.7495 60.1024 23.2329 60.4104 23.5444C60.7183 23.856 61.1785 24.0117 61.7908 24.0117C62.2133 24.0117 62.557 23.9383 62.822 23.7915C63.0906 23.6411 63.2875 23.4227 63.4128 23.1362C63.5417 22.8462 63.6062 22.4971 63.6062 22.0889V17.1475H64.8899ZM73.7142 20.9985C73.7142 21.883 73.5494 22.6224 73.22 23.2168C72.8906 23.8076 72.4126 24.2534 71.7859 24.5542C71.1593 24.8514 70.4038 25 69.5193 25H67.3387V17.1475H69.7557C70.5685 17.1475 71.2703 17.2943 71.8611 17.5879C72.452 17.8779 72.9085 18.3094 73.2308 18.8823C73.553 19.4517 73.7142 20.1571 73.7142 20.9985ZM72.3714 21.0361C72.3714 20.3916 72.2693 19.8617 72.0652 19.4463C71.8647 19.0309 71.5675 18.723 71.1736 18.5225C70.7833 18.3184 70.3017 18.2163 69.7288 18.2163H68.6277V23.9204H69.5408C70.4897 23.9204 71.1987 23.6787 71.6678 23.1953C72.1368 22.7119 72.3714 21.9922 72.3714 21.0361ZM80.2933 25H75.8461V17.1475H80.2933V18.2324H77.1351V20.3647H80.0946V21.4443H77.1351V23.9097H80.2933V25ZM86.9638 22.8623C86.9638 23.3278 86.8492 23.7288 86.62 24.0654C86.3945 24.402 86.0686 24.6598 85.6425 24.8389C85.22 25.0179 84.7151 25.1074 84.1279 25.1074C83.8414 25.1074 83.5675 25.0913 83.3061 25.0591C83.0447 25.0269 82.7976 24.9803 82.5649 24.9194C82.3357 24.855 82.1262 24.778 81.9364 24.6885V23.4746C82.2551 23.6143 82.6114 23.7414 83.0053 23.856C83.3992 23.967 83.8002 24.0225 84.2084 24.0225C84.5414 24.0225 84.8171 23.9795 85.0356 23.8936C85.2576 23.804 85.4223 23.6787 85.5297 23.5176C85.6371 23.3529 85.6908 23.1613 85.6908 22.9429C85.6908 22.7101 85.6282 22.5132 85.5029 22.3521C85.3775 22.1909 85.1877 22.0441 84.9335 21.9116C84.6829 21.7756 84.3678 21.6305 83.9882 21.4766C83.7304 21.3727 83.4833 21.2546 83.247 21.1221C83.0142 20.9896 82.8066 20.8338 82.6239 20.6548C82.4413 20.4757 82.2963 20.2645 82.1889 20.021C82.085 19.7739 82.0331 19.4839 82.0331 19.1509C82.0331 18.7069 82.1388 18.3273 82.35 18.0122C82.5649 17.6971 82.8656 17.4554 83.2524 17.2871C83.6427 17.1188 84.0974 17.0347 84.6166 17.0347C85.0284 17.0347 85.4151 17.0776 85.7768 17.1636C86.142 17.2495 86.5001 17.3713 86.851 17.5288L86.4428 18.5654C86.1205 18.4329 85.8072 18.3273 85.5029 18.2485C85.2021 18.1698 84.8941 18.1304 84.579 18.1304C84.3069 18.1304 84.0759 18.1715 83.8862 18.2539C83.6964 18.3363 83.5514 18.4526 83.4511 18.603C83.3544 18.7498 83.3061 18.9253 83.3061 19.1294C83.3061 19.3586 83.3616 19.5519 83.4726 19.7095C83.5872 19.8634 83.7626 20.0049 83.9989 20.1338C84.2389 20.2627 84.5468 20.4059 84.9228 20.5635C85.356 20.7425 85.7231 20.9305 86.0238 21.1274C86.3282 21.3244 86.561 21.5607 86.7221 21.8364C86.8832 22.1086 86.9638 22.4505 86.9638 22.8623ZM94.4395 20.73L96.3033 17.1475H97.6944L95.084 21.9492V25H93.8003V21.9976L91.1846 17.1475H92.5865L94.4395 20.73ZM106.137 21.063C106.137 21.6681 106.06 22.2196 105.906 22.7173C105.756 23.2114 105.529 23.6375 105.224 23.9956C104.92 24.3501 104.539 24.624 104.08 24.8174C103.622 25.0107 103.085 25.1074 102.469 25.1074C101.842 25.1074 101.298 25.0107 100.836 24.8174C100.378 24.624 99.9964 24.3483 99.692 23.9902C99.3912 23.6322 99.1656 23.2043 99.0152 22.7065C98.8648 22.2088 98.7896 21.6574 98.7896 21.0522C98.7896 20.243 98.9221 19.5376 99.1871 18.936C99.4557 18.3309 99.8621 17.8618 100.406 17.5288C100.954 17.1922 101.645 17.0239 102.48 17.0239C103.296 17.0239 103.975 17.1904 104.515 17.5234C105.056 17.8564 105.461 18.3255 105.729 18.9307C106.001 19.5322 106.137 20.243 106.137 21.063ZM100.143 21.063C100.143 21.6681 100.226 22.1927 100.39 22.6367C100.555 23.0771 100.807 23.4173 101.148 23.6572C101.491 23.8936 101.932 24.0117 102.469 24.0117C103.01 24.0117 103.45 23.8936 103.79 23.6572C104.13 23.4173 104.381 23.0771 104.542 22.6367C104.703 22.1927 104.784 21.6681 104.784 21.063C104.784 20.1427 104.599 19.423 104.231 18.9038C103.865 18.381 103.282 18.1196 102.48 18.1196C101.942 18.1196 101.5 18.2378 101.153 18.4741C100.809 18.7104 100.555 19.0488 100.39 19.4893C100.226 19.9261 100.143 20.4507 100.143 21.063ZM114.43 17.1475V22.2285C114.43 22.7764 114.313 23.2669 114.081 23.7002C113.852 24.1335 113.504 24.4772 113.039 24.7314C112.573 24.9821 111.988 25.1074 111.282 25.1074C110.276 25.1074 109.51 24.8442 108.984 24.3179C108.461 23.7879 108.199 23.0843 108.199 22.207V17.1475H109.488V22.0942C109.488 22.7495 109.642 23.2329 109.95 23.5444C110.258 23.856 110.718 24.0117 111.331 24.0117C111.753 24.0117 112.097 23.9383 112.362 23.7915C112.631 23.6411 112.827 23.4227 112.953 23.1362C113.082 22.8462 113.146 22.4971 113.146 22.0889V17.1475H114.43ZM119.602 25H118.307V18.2432H116.009V17.1475H121.895V18.2432H119.602V25ZM129.704 17.1475V22.2285C129.704 22.7764 129.588 23.2669 129.355 23.7002C129.126 24.1335 128.779 24.4772 128.313 24.7314C127.848 24.9821 127.262 25.1074 126.557 25.1074C125.551 25.1074 124.784 24.8442 124.258 24.3179C123.735 23.7879 123.474 23.0843 123.474 22.207V17.1475H124.763V22.0942C124.763 22.7495 124.917 23.2329 125.225 23.5444C125.533 23.856 125.993 24.0117 126.605 24.0117C127.028 24.0117 127.372 23.9383 127.637 23.7915C127.905 23.6411 128.102 23.4227 128.227 23.1362C128.356 22.8462 128.421 22.4971 128.421 22.0889V17.1475H129.704ZM132.153 17.1475H134.49C135.503 17.1475 136.267 17.2943 136.783 17.5879C137.299 17.8815 137.556 18.3882 137.556 19.1079C137.556 19.4087 137.503 19.6808 137.395 19.9243C137.292 20.1642 137.139 20.363 136.939 20.5205C136.738 20.6745 136.491 20.7783 136.198 20.832V20.8857C136.502 20.9395 136.772 21.0343 137.009 21.1704C137.249 21.3065 137.437 21.5016 137.573 21.7559C137.712 22.0101 137.782 22.3395 137.782 22.7441C137.782 23.224 137.667 23.6322 137.438 23.9688C137.213 24.3053 136.889 24.5614 136.466 24.7368C136.047 24.9123 135.549 25 134.973 25H132.153V17.1475ZM133.442 20.3862H134.678C135.261 20.3862 135.666 20.2913 135.891 20.1016C136.117 19.9118 136.23 19.6343 136.23 19.269C136.23 18.8966 136.096 18.6281 135.827 18.4634C135.562 18.2987 135.139 18.2163 134.559 18.2163H133.442V20.3862ZM133.442 21.4282V23.9204H134.801C135.403 23.9204 135.825 23.804 136.069 23.5713C136.312 23.3385 136.434 23.0234 136.434 22.626C136.434 22.3825 136.378 22.1712 136.267 21.9922C136.16 21.8132 135.983 21.6753 135.736 21.5786C135.489 21.4784 135.156 21.4282 134.737 21.4282H133.442ZM144.291 25H139.844V17.1475H144.291V18.2324H141.133V20.3647H144.093V21.4443H141.133V23.9097H144.291V25ZM154.259 22.8623C154.259 23.3278 154.145 23.7288 153.916 24.0654C153.69 24.402 153.364 24.6598 152.938 24.8389C152.515 25.0179 152.011 25.1074 151.423 25.1074C151.137 25.1074 150.863 25.0913 150.602 25.0591C150.34 25.0269 150.093 24.9803 149.86 24.9194C149.631 24.855 149.422 24.778 149.232 24.6885V23.4746C149.551 23.6143 149.907 23.7414 150.301 23.856C150.695 23.967 151.096 24.0225 151.504 24.0225C151.837 24.0225 152.113 23.9795 152.331 23.8936C152.553 23.804 152.718 23.6787 152.825 23.5176C152.933 23.3529 152.986 23.1613 152.986 22.9429C152.986 22.7101 152.924 22.5132 152.798 22.3521C152.673 22.1909 152.483 22.0441 152.229 21.9116C151.978 21.7756 151.663 21.6305 151.284 21.4766C151.026 21.3727 150.779 21.2546 150.543 21.1221C150.31 20.9896 150.102 20.8338 149.919 20.6548C149.737 20.4757 149.592 20.2645 149.484 20.021C149.381 19.7739 149.329 19.4839 149.329 19.1509C149.329 18.7069 149.434 18.3273 149.646 18.0122C149.86 17.6971 150.161 17.4554 150.548 17.2871C150.938 17.1188 151.393 17.0347 151.912 17.0347C152.324 17.0347 152.711 17.0776 153.072 17.1636C153.438 17.2495 153.796 17.3713 154.147 17.5288L153.738 18.5654C153.416 18.4329 153.103 18.3273 152.798 18.2485C152.498 18.1698 152.19 18.1304 151.875 18.1304C151.602 18.1304 151.371 18.1715 151.182 18.2539C150.992 18.3363 150.847 18.4526 150.747 18.603C150.65 18.7498 150.602 18.9253 150.602 19.1294C150.602 19.3586 150.657 19.5519 150.768 19.7095C150.883 19.8634 151.058 20.0049 151.294 20.1338C151.534 20.2627 151.842 20.4059 152.218 20.5635C152.652 20.7425 153.019 20.9305 153.319 21.1274C153.624 21.3244 153.856 21.5607 154.018 21.8364C154.179 22.1086 154.259 22.4505 154.259 22.8623ZM162.38 17.1475V22.2285C162.38 22.7764 162.264 23.2669 162.031 23.7002C161.802 24.1335 161.454 24.4772 160.989 24.7314C160.523 24.9821 159.938 25.1074 159.232 25.1074C158.226 25.1074 157.46 24.8442 156.934 24.3179C156.411 23.7879 156.149 23.0843 156.149 22.207V17.1475H157.439V22.0942C157.439 22.7495 157.593 23.2329 157.9 23.5444C158.208 23.856 158.669 24.0117 159.281 24.0117C159.703 24.0117 160.047 23.9383 160.312 23.7915C160.581 23.6411 160.778 23.4227 160.903 23.1362C161.032 22.8462 161.096 22.4971 161.096 22.0889V17.1475H162.38ZM168.218 25L165.957 18.4419H165.908C165.919 18.5887 165.932 18.7892 165.946 19.0435C165.96 19.2977 165.973 19.5698 165.984 19.8599C165.994 20.1499 166 20.4274 166 20.6924V25H164.829V17.1475H166.639L168.814 23.4155H168.846L171.097 17.1475H172.902V25H171.672V20.6279C171.672 20.388 171.675 20.1284 171.682 19.8491C171.693 19.5698 171.704 19.3049 171.714 19.0542C171.729 18.8035 171.74 18.603 171.747 18.4526H171.704L169.357 25H168.218ZM178.799 25L176.537 18.4419H176.489C176.5 18.5887 176.512 18.7892 176.527 19.0435C176.541 19.2977 176.553 19.5698 176.564 19.8599C176.575 20.1499 176.58 20.4274 176.58 20.6924V25H175.409V17.1475H177.219L179.395 23.4155H179.427L181.677 17.1475H183.482V25H182.252V20.6279C182.252 20.388 182.256 20.1284 182.263 19.8491C182.274 19.5698 182.284 19.3049 182.295 19.0542C182.309 18.8035 182.32 18.603 182.327 18.4526H182.284L179.937 25H178.799ZM190.856 25L190.088 22.8193H187.086L186.318 25H184.959L187.881 17.1152H189.309L192.226 25H190.856ZM189.755 21.7129L189.009 19.5645C188.98 19.4714 188.939 19.3407 188.885 19.1724C188.831 19.0005 188.778 18.8268 188.724 18.6514C188.67 18.4723 188.625 18.3219 188.59 18.2002C188.554 18.347 188.509 18.5117 188.455 18.6943C188.405 18.8734 188.355 19.0417 188.305 19.1992C188.258 19.3568 188.223 19.4785 188.198 19.5645L187.446 21.7129H189.755ZM195.91 17.1475C196.587 17.1475 197.145 17.2298 197.586 17.3945C198.03 17.5592 198.359 17.8099 198.574 18.1465C198.792 18.4831 198.902 18.911 198.902 19.4302C198.902 19.8169 198.83 20.1463 198.687 20.4185C198.544 20.6906 198.356 20.9162 198.123 21.0952C197.89 21.2743 197.641 21.4175 197.376 21.5249L199.605 25H198.15L196.254 21.8525H194.992V25H193.702V17.1475H195.91ZM195.824 18.2217H194.992V20.7891H195.883C196.481 20.7891 196.914 20.6781 197.183 20.4561C197.455 20.234 197.591 19.9064 197.591 19.4731C197.591 19.0184 197.446 18.6961 197.156 18.5063C196.87 18.3166 196.426 18.2217 195.824 18.2217ZM203.391 20.73L205.255 17.1475H206.646L204.036 21.9492V25H202.752V21.9976L200.137 17.1475H201.538L203.391 20.73Z"
                  fill="white"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_10_37"
                  x="0"
                  y="0"
                  width="254"
                  height="57"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="8" dy="8" />
                  <feGaussianBlur stdDeviation="7.5" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_10_37"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_10_37"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <div>
            <img className="box-img" src={newChatIcon} alt="box img 1" />
          </div>
          <div className="box-title">WritelyCHAT</div>
          <div className="box-desc">Everything you can imagine!</div>
        </div>
      </div>
      <div className="btn-section">
        {/* <button
          disabled={selectedBox === ""}
          className={`hover-zoom trial-btn ${
            selectedBox === "" ? "disabled-trial-btn" : ""
          }`}
          onClick={() => {
            trackButtonClick("Login Entery Modal", "Start Now");
            if (selectedBox === "chat") {
              history.push(Paths.emptyChat);
            } else {
              startNow(selectedBox);
            }
          }}
        >
          {" "}
          Start Now{" "}
        </button> */}
      </div>
    </div>
  );
};

export default LoginModal;
